import { Component, HostBinding, Input, OnChanges } from "@angular/core";
import * as _ from "lodash";

import { resolveSponsorLogoByKey } from "src/app/services/sponsor-logo/sponsor-logo";

/**
 * Renders the sponsor logo of the product open in product details.
 *
 * Same rule as the kiosk product details: the logo shows whenever the product
 * declares a sponsor in `kiosk_design_settings.sponsorLogo` that resolves to a
 * logo URL. There is no store whitelist here; the cart banner keeps its
 * `storeInfo.design_settings.cartSponsorLogos` whitelist. A missing or unknown
 * sponsor and an image that fails to load (missing/404) render nothing.
 * Display-only: it does not touch the product selection, prices or the cart.
 */
@Component({
  selector: "app-product-sponsor-logo",
  templateUrl: "./product-sponsor-logo.component.html",
  styleUrls: ["./product-sponsor-logo.component.scss"],
})
export class ProductSponsorLogoComponent implements OnChanges {
  @Input() product: any;

  // Without a logo the host is hidden, so it leaves no box (or margin) behind,
  // for example in the end slot of the product title item.
  @HostBinding("class.product-sponsor-logo-hidden") public hidden = true;

  public sponsorLogoUrl: string | null = null;

  private failedUrls: string[] = []; // logo URLs whose image failed to load

  ngOnChanges() {
    const sponsorLogo =
      this.product &&
      this.product.kiosk_design_settings &&
      this.product.kiosk_design_settings.sponsorLogo;
    const url = sponsorLogo ? resolveSponsorLogoByKey(sponsorLogo) : null;
    this.sponsorLogoUrl = url && !_.includes(this.failedUrls, url) ? url : null;
    this.hidden = !this.sponsorLogoUrl;
  }

  /** Hide a sponsor logo whose image failed to load (missing/404). */
  public onImageError() {
    if (
      this.sponsorLogoUrl &&
      !_.includes(this.failedUrls, this.sponsorLogoUrl)
    ) {
      this.failedUrls.push(this.sponsorLogoUrl);
    }
    this.sponsorLogoUrl = null;
    this.hidden = true;
  }
}
